import React, { useEffect,  useState } from "react";
import axios from "axios"; 
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Brands.css";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";


const BrandsSlider = () => {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    axios
      .get("https://www.isolsgroup.com/new/api/ApiBrands", {
        headers: {
          "X-API-KEY": "ISOLS", // 🔐 Replace with your actual key if required
        },
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          setBrands(response.data.data);
        } else {
          console.warn("Unexpected API response:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching brand data:", error);
      });
  }, []); 


  const settings = {
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 600, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <section className="bussiness ">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <h2
              style={{
                fontSize: "25px",
                color: "#ff9600",
                lineHeight: "1.2",
                textAlign: "center",
                fontFamily: "Raleway",
                fontWeight: "700",
                fontStyle: "normal",
                padding: "0 0 10px 30px",
                textTransform: "uppercase",
              }}
              className="vc_custom_heading vc_custom_1490112359046"
            >
              Brands we are empowering
            </h2>
            {brands.length > 0 ? (
            <Slider {...settings} className="customer-logos slider">
              {brands.map((brand, index) => (
                <div className="slide" key={index}>
                  {/* <img src={brand} className="img-100" alt={`Brand ${index + 1}`} />
                   */}
                  <img
                  src={`https://www.isolsgroup.com/new/uploaded-images/client/${brand.client_image}`}
                  alt={brand.client_name || "Brand logo"}
                  className="img-100"
                  />
                </div>
              ))}
            </Slider>
            ) : (
              <p className="text-center mt-4">No brands available.</p>
            )}
            <div className="aboutt">
                <Link to="/clients" className="btn btn-default-arrow btn-sm">
                <FaArrowRight />
                    Explore More
                </Link>
                </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSlider;
